import { Component } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, NgForm } from '@angular/forms';
import { AuthenticationService } from '../services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertsService } from 'angular-alert-module';
import { ChangePassword } from '../change_password/change_password.model';
import Swal from 'sweetalert2';

@Component({
  templateUrl: './forgot_password.component.html',
  styleUrls: [ './forgot_password.component.scss' ]
})

export class ForgotPasswordComponent {
  myForm: FormGroup;
  submitted: boolean = false;
  email: any;

  // Form controls
  pswd = new FormGroup({
    email: new FormControl(''),
  });
  password: ChangePassword = {
    email: '',
    oldpassword: '',
    newpassword: ''
  };
  hostNameProtocol: string;
  hostNameFromWeb: string;
  actualHostName: string;

   constructor(private auth: AuthenticationService, private activatedRoute: ActivatedRoute, private router: Router,
               private formBuilder: FormBuilder, private alerts: AlertsService) {}


    ngOnInit() {




      this.myForm = this.formBuilder.group(
        {
          email: ['', [Validators.required, Validators.email]]
        }
      );


      this.hostNameProtocol = window.location.protocol 
      this.hostNameFromWeb = window.location.host
      this.actualHostName = this.hostNameProtocol.concat("//",this.hostNameFromWeb)
      console.log("Printing the hostname in forgot password component",this.actualHostName);
    }
    get f() { return this.myForm.controls; }

    forgotpassword() {
      this.submitted = true;
      if (this.myForm.invalid) {
        console.log("inside invalid",this.myForm.invalid)
        //
        // this.submitted = false
        return;
      }else{
      this.auth.forgotpassword(this.password,this.actualHostName).subscribe(
        (data) => {
          this.submitted = true;

          if (data.code === 200) {


            Swal.fire({
              title: 'Success',
              text: data.success,
              icon: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.isConfirmed) {
                this.router.navigateByUrl('/');
              }
            })

          } else if (data.code === 400) {
              Swal.fire({
                title: 'Alert',
                text: data.failed,
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: 'OK'
              }).then((result) => {
                if (result.isConfirmed) {
                  // this.router.navigateByUrl('/test_scheduler');
                }
              })

            }
          },
        err => {
          console.error(err);
          // alert('Email id does not exist');
        }
      );
      }
    }

    Oncancel() {
        this.router.navigateByUrl('/');
    }
}
